import { GET_ALLOWANCE_LIST_SUCCESS, GET_ALLOWANCE_PRESENCE_TICKET_MEETING_LIST_SUCCESS } from "../action-types/allowance";

const initialState = {
    allowances: [],
    meetings: []
};

const allowanceReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ALLOWANCE_LIST_SUCCESS:
            return {
                ...state,
                allowances: action.allowances.allowances
            };
        case GET_ALLOWANCE_PRESENCE_TICKET_MEETING_LIST_SUCCESS:
            return {
                ...state,
                meetings: action.meetings.meetings
            };
        default:
            return state;
    }
}

export default allowanceReducer;